/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 02.06.17.
 */

import React from "react";
import {Link} from "react-router";
import PropTypes from "prop-types";
import _ from "underscore";
import BasePageFrame from "./BasePageFrame";
import SchemaRegistry from "../../../services/SchemaRegistry";
import Navigation from "../../../Navigation";

class Tabbed extends BasePageFrame {
    static propTypes = {
        navResource: PropTypes.string.isRequired,
        params: PropTypes.shape({
            path: PropTypes.string.isRequired,
            resource: PropTypes.string.isRequired,
            action: PropTypes.oneOf(["list","new","view","edit","delete"]).isRequired,
            id: PropTypes.string,
            query: PropTypes.object,
            tab: PropTypes.string,
            parentPath: PropTypes.string,
            parentResource: PropTypes.string,
            parentAction: PropTypes.oneOf(["list","new","view","edit","delete"]),
            parentId: PropTypes.string,
            parentField: PropTypes.string,
            parentTab: PropTypes.string,
            isModal: PropTypes.bool
        }).isRequired,
        location: PropTypes.object.isRequired,
        router: PropTypes.object.isRequired,
        route: PropTypes.object.isRequired,
        options: PropTypes.shape({
            component: PropTypes.arrayOf(PropTypes.string).isRequired,
            schema: PropTypes.arrayOf(PropTypes.string),
            tabs: PropTypes.arrayOf(PropTypes.string)
        }).isRequired
    };

    static defaultProps = {};

    getSchema(schemaName) {
        return SchemaRegistry.getSchemaObject(this.props.params.parentResource, this.props.navResource, schemaName);
    }

    getUrlForTab(tab) {
        let path = this.props.params.path;
        let hash = path.indexOf("#");
        if (hash >= 0) path = path.substring(0, hash);
        return path + "#" + tab;
    }

    getTabName(i) {
        let tab = (this.props.options.tabs ? this.props.options.tabs[i] : null);
        if (!tab) tab = "tab" + (i+1).toString();
        return tab;
    }

    getTabIndex(tab) {
        let index = -1;
        if (this.props.options.tabs) {
            index = _.findIndex(this.props.options.tabs, function (item) {
                return item === tab;
            });
        } else {
            index = Number.parseInt(tab.substring(3));
            if (isNaN(index)) index = -1;
        }
        return (index < 0 ? 0 : index);

    }

    renderTabTitles() {
        let schemas = _.map(this.props.options.schema, (item) => {
            return this.getSchema(item);
        });
        let i = -1;
        let activeTab = this.getTabIndex(this.props.params.tab);
        return (
            <ul className="nav nav-tabs">
                {
                    _.map(schemas, (schema) => {
                        i++;
                        return (<li key={i} className={(i === activeTab ? "active" : "")}><Link to={this.getUrlForTab(this.getTabName(i))}>{schema.getTitle()}</Link></li>);
                    })
                }
            </ul>
        );
    }

    renderPageComponentWithFrame(component) {
        return (
            <div className="panel-body">
                {component}
            </div>
        );
    }

    renderTabContent() {
        let component = this.getPageComponent(this.getTabIndex(this.props.params.tab));
        return (
            <div className="tab-content">
                <div className="tab-pane active">
                    {component}
                </div>
            </div>
        );
    }

    renderBody() {
        return (
            <div className="row">
                <div className="col-lg-12">
                    <div className="tabs-container">
                        {this.renderTabTitles()}
                        {this.renderTabContent()}
                    </div>
                </div>
            </div>
        );
    }
}

export default Tabbed;
